import { render, staticRenderFns } from "./WordcloudTable.vue?vue&type=template&id=64d352d4&scoped=true&"
import script from "./WordcloudTable.vue?vue&type=script&lang=js&"
export * from "./WordcloudTable.vue?vue&type=script&lang=js&"
import style0 from "./WordcloudTable.vue?vue&type=style&index=0&id=64d352d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d352d4",
  null
  
)

export default component.exports